export const mustFillMessage = 'Bidang formulir ini wajib diisi';
export const numericDigitOnlyMessage = 'Hanya menerima angka';
export const tooLongMessage = 'Isian bidang terlalu panjang';
export const nimNotValidMessage = 'NIM tidak valid';
export const emailNotValidMessage = 'Email tidak valid';
export const submitMessage = 'Kirim';
export const browseFileMessage = 'Pilih';
export const incorrectFileTypeMessage = 'Tipe file tidak sesuai';
export const fileTooBigMessage = 'Ukuran file terlalu besar';

export const submittinFormMessage = 'Mengirimkan formulir...';
export const submittedFormMessage = 'Formulir terkirim...';
export const tokenNotFoundMessage = 'Token tidak valid';
export const loginSuccMessage = 'Berhasil Login';
